import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[app-add-sm-button]',
  exportAs: 'appAddSmButton'
})
export class AddSmButtonDirective {

  @Input() isOn: boolean = false
  @Output() isOnChange = new EventEmitter()
  constructor() { }

  isOnToggle(){
    this.isOn = this.isOn == false ? true : false
    console.log('toggle value', this.isOn)
  }

}
